import React, { useState } from "react";
import Header from "./Components/Header";
import Home from "./Components/Home";
import About from "./Components/Aboutus";
import Contact from "./Components/ContactusSection";
import Footer from "./Components/Footer";
import Legal from "./Components/Legal";
import Terms from "./Components/Terms";
import Applynow from "./Components/Applynow";
import Verification from "./Components/Verification";
import BusinessSolution from "./Components/BusinessSolution";

function App() {
  const [route, setRoute] = useState(window.location.pathname);

  const navigateTo = (path) => {
    window.history.pushState({}, path, window.location.origin + path);
    setRoute(path);
  };

  const renderComponent = () => {
    switch (route) {
      case "/":
        return <Home />;
      case "/Aboutus.jsx":
        return <About />;
      case "/contact":
        return <Contact />;
      case "/Legal.jsx":
        return <Legal />;
      case "/Terms.jsx":
        return <Terms />;
      case "/Applynow.jsx":
        return <Applynow />;
      case "/Verification.jsx":
        return <Verification />;
      default:
        return <Home />;
    }
  };

  return (
    <div>
      <Header />
      {renderComponent()}
      <Footer />
    </div>
  );
}

export default App;
